module.exports = __webpack_public_path__ + "media/stable/components/site/review_label/assets/rating_star-68a9ba4c09c5660fc77f75430fb32341.svg";